<div [ngStyle]="{'display':linksLoaded ? 'block' : 'none'}" class="content">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
    <a mat-tab-link class="d-none d-md-inline-flex" *ngFor="let e of mainLinks"  [routerLink]="!e.disabled ? e.link : null" routerLinkActive
      #rla="routerLinkActive" [active]="rla.isActive"  [disabled]="e.disabled" [attr.tabindex]="e.disabled ? '-1' : null">
      <cqes-icon [icon]="e.icon"></cqes-icon>
      {{e.label | translate}}
    </a>
    <span class="nav-responsive d-md-none" *ngFor="let e of mainLinks"  [routerLink]="!e.disabled ? e.link : null" routerLinkActive
      #rla="routerLinkActive" [matMenuTriggerFor]="clientMenu"  [disabled]="e.disabled" [attr.tabindex]="e.disabled ? '-1' : null">
      <a *ngIf="rla.isActive" mat-tab-link>
        <cqes-icon icon="menu"></cqes-icon>{{e.label | translate}}
      </a>
    </span>
  </nav>

  <mat-menu #clientMenu="matMenu" [overlapTrigger]="false" class="nav-responsive-overlay">
    <button mat-menu-item *ngFor="let e of mainLinks" [routerLink]="e.link" routerLinkActive="active">
      <cqes-icon [icon]="e.icon"></cqes-icon>
      {{e.label | translate}}
    </button>
  </mat-menu>

  <cloud-profile-remaining-count *ngIf="!isEmergencyLogin"></cloud-profile-remaining-count>

  <div [@routeAnimations]="prepareOutlet(o)">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="main-heading" translate>{{componentTitle}}</h1>
          <router-outlet #o="outlet"></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>